import { DropZone, FileInput } from '@snsw/react-component-library';
import { ChangeEvent, DragEvent, ReactNode } from 'react';

interface Props {
  id: string;
  name: string;
  helpMessage?: ReactNode;
  onChange: (files: FileList) => Promise<void>;

  disableDragDrop?: boolean;
  hasError?: boolean;
  allowMultiple?: boolean;
  acceptedFormats?: string;
}

export const FileUploadInput = ({
  id,
  name,
  helpMessage,
  disableDragDrop,
  hasError,
  onChange,
  allowMultiple,
  acceptedFormats,
}: Props) => {
  const handleChange = async (event: ChangeEvent<HTMLInputElement>) => {
    await onChange(event.target.files);
  };

  const handleDrop = async (e: DragEvent) => await onChange(e.dataTransfer.files);

  const fileInput = (
    <FileInput
      id={`${id}-fileinput`}
      name={name}
      onChange={handleChange}
      multiple={allowMultiple}
      accept={acceptedFormats}
      label={allowMultiple ? 'Select files' : 'Select file'}
    />
  );

  if (!disableDragDrop) {
    return (
      <DropZone
        showUploadIcon
        helpMessage={helpMessage}
        id={`${id}-dropzone`}
        testId={`${id}-dropzone`}
        onDrop={handleDrop}
        hasError={hasError}
        fileInput={fileInput}
      />
    );
  }

  return (
    <>
      {helpMessage}
      {fileInput}
    </>
  );
};
